module.exports = __webpack_public_path__ + "media/images/riders/small/HALEY_SMITH-06ae1378ca7ab9d3ca07154372b54d9b.png";